import React from 'react';
import '../less';
import { Link } from 'MWC';
import backgroundLine from "../img/background-line.png";
import heroArrow1 from "../img/hero-arrow-3.png"
import heroArrow2 from "../img/hero-arrow-1.png"
import heroArrow3 from "../img/hero-arrow-2.png"
import heroArrow4 from "../img/hero-arrow-4.png"
import searchIcon from "../img/search-icon.svg"
import ExchangeRatesNew from '../../../auxiliary-components/ExchangeRatesNew';
import servicesRight1 from "../img/services-right-1.svg"
import servicesRight2 from "../img/services-right-2.svg"
import servicesRight3 from "../img/services-right-3.svg"
import NewsNew from '../views/news-new.c';
import Slider from 'react-slick';
import moreSliderArrow1 from "../img/more-slider-arrow-1.svg"
import moreSliderArrow2 from "../img/more-slider-arrow-2.svg"
import moreSliderImg1 from "../img/more-slider-img-1.png"
import moreSliderImg2 from "../img/more-slider-img-2.png"
import moreSliderImg3 from "../img/more-slider-img-3.png"
import moreSliderImg4 from "../img/more-slider-img-4.png"
import moreSliderImg5 from "../img/more-slider-img-5.png"
import moreSliderImg6 from "../img/more-slider-img-6.png"
import moreSliderImg7 from "../img/more-slider-img-7.png"
import moreSliderImg8 from "../img/more-slider-img-8.png"
import proposalTabs from "../img/proposal-tabs.svg"

import proposalSliderDesktop2 from "../img/proposal/desktop/proposal-slider-desktop-12.png"
import proposalSliderDesktop3 from "../img/proposal/desktop/proposal-slider-desktop-3.png"
import proposalSliderDesktop4 from "../img/proposal/desktop/proposal-slider-desktop-4.png"
import proposalSliderDesktop5 from "../img/proposal/desktop/proposal-slider-desktop-5.png"
import proposalSliderDesktop6 from "../img/proposal/desktop/proposal-slider-desktop-6.png"
import proposalSliderDesktop7 from "../img/proposal/desktop/proposal-slider-desktop-7.png"
import proposalSliderDesktop8 from "../img/proposal/desktop/proposal-slider-desktop-8.png"
import proposalSliderDesktop9 from "../img/proposal/desktop/proposal-slider-desktop-9.png"
import proposalSliderDesktop11 from "../img/proposal/desktop/proposal-slider-desktop-11.png"

import proposalSliderTablet2 from "../img/proposal/tablet/proposal-slider-tablet-12.png"
import proposalSliderTablet3 from "../img/proposal/tablet/proposal-slider-tablet-3.png"
import proposalSliderTablet4 from "../img/proposal/tablet/proposal-slider-tablet-4.png"
import proposalSliderTablet5 from "../img/proposal/tablet/proposal-slider-tablet-5.png"
import proposalSliderTablet6 from "../img/proposal/tablet/proposal-slider-tablet-6.png"
import proposalSliderTablet7 from "../img/proposal/tablet/proposal-slider-tablet-7.png"
import proposalSliderTablet8 from "../img/proposal/tablet/proposal-slider-tablet-8.png"
import proposalSliderTablet9 from "../img/proposal/tablet/proposal-slider-tablet-9.png"
import proposalSliderTablet11 from "../img/proposal/tablet/proposal-slider-tablet-11.png"

import proposalSliderMobile2 from "../img/proposal/mobile/proposal-slider-mobile-12.png"
import proposalSliderMobile3 from "../img/proposal/mobile/proposal-slider-mobile-3.png"
import proposalSliderMobile4 from "../img/proposal/mobile/proposal-slider-mobile-4.png"
import proposalSliderMobile5 from "../img/proposal/mobile/proposal-slider-mobile-5.png"
import proposalSliderMobile6 from "../img/proposal/mobile/proposal-slider-mobile-6.png"
import proposalSliderMobile7 from "../img/proposal/mobile/proposal-slider-mobile-7.png"
import proposalSliderMobile8 from "../img/proposal/mobile/proposal-slider-mobile-8.png"
import proposalSliderMobile9 from "../img/proposal/mobile/proposal-slider-mobile-9.png"
import proposalSliderMobile11 from "../img/proposal/mobile/proposal-slider-mobile-11.png"

import proposalSliderTabletMobile2 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-12.png"
import proposalSliderTabletMobile3 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-3.png"
import proposalSliderTabletMobile4 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-4.png"
import proposalSliderTabletMobile5 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-5.png"
import proposalSliderTabletMobile6 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-6.png"
import proposalSliderTabletMobile7 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-7.png"
import proposalSliderTabletMobile8 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-8.png"
import proposalSliderTabletMobile9 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-9.png"
import proposalSliderTabletMobile11 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-11.png"

import cashbackBg from "../img/proposal/background/cashback-bg.svg"
import atbBg from "../img/proposal/background/atb-bg.svg"
import vygodaBg from "../img/proposal/background/vygoda-bg.svg"
import cashbackBigBg from "../img/proposal/background/cashback-big-bg.svg"
import veteranBg from "../img/proposal/background/veteran-bg.svg"
import bookBg from "../img/proposal/background/book-bg.svg"
import pbpBg from "../img/proposal/background/pbp-bg.svg"
import boltBg from "../img/proposal/background/bolt-bg.svg"

import proposalArrow from "../img/proposal-arrow.svg"

import {
  URL_BOLT,
  URL_CASHBACK,
  URL_ATB,
  URL_VYGODA,
  URL_INSTALLMENT,
  URL_ENERGY,
  URL_PBP,
  URL_SEARCH,
  URL_BRANCHES,
  URL_SERVICES,
  URL_CONTACTS,
  URL_INVITE_FRIEND,
  URL_INSURANCE,
  URL_SAFE_BOXES,
  URL_ACQUIRING,
  URL_BECOME_PARTNER,
  URL_TRANSFERS,
  URL_QUICK_CASH,
  URL_VETERAN,
  URL_BOOK
} from '../variables';

export default function template() {
    const { isMobile, isTablet, isDesktop, isMiddle } = this.state;

    const settings = {
      dots: false, 
      infinite: true, 
      swipeToSlide: true,
      variableWidth: true,
      arrows: false,
      speed: 500,
      touchMove: true,
      draggable: true,
      swipe: true,
      afterChange: index => this.handleSlideChange(index),
      autoplaySpeed: 3000,
      onSwipe: this.handleSwipe,
    };

    const settingsProposal = {
      dots: false, 
      infinite: true, 
      swipeToSlide: true,
      variableWidth: true,
      arrows: false,
      speed: 500,
      touchMove: true,
      draggable: true,
      swipe: true,
      autoplaySpeed: 3000,
      onSwipe: this.handleSwipeProposal,
    };
    
    const settingsTabs = {
      dots: false, 
      infinite: true, 
      swipeToSlide: true,
      variableWidth: true,
      arrows: false,
      speed: 500,
      touchMove: true,
      draggable: true,
      swipe: true,
    };

    const slides = [
      { img: moreSliderImg1, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_1'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_1'), link: URL_INVITE_FRIEND },
      { img: moreSliderImg2, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_2'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_2'), link: URL_INSTALLMENT },
      { img: moreSliderImg3, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_3'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_3'), link: URL_INSURANCE },
      { img: moreSliderImg4, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_4'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_4'), link: URL_SAFE_BOXES },
      { img: moreSliderImg5, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_5'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_5'), link: URL_ACQUIRING },
      { img: moreSliderImg6, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_6'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_6'), link: URL_BECOME_PARTNER },
      { img: moreSliderImg7, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_7'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_7'), link: URL_TRANSFERS },
      { img: moreSliderImg8, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_8'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_8'), link: URL_QUICK_CASH }
    ];

    const modes = [ {mode: 'recommended', img: proposalTabs, title: this.l10n('HOME_NEW_MODES_TITLE_1')},
      {mode: 'youth', title: this.l10n('HOME_NEW_MODES_TITLE_2')},
      {mode: 'family', title: this.l10n('HOME_NEW_MODES_TITLE_3')},
      {mode: 'old', title: this.l10n('HOME_NEW_MODES_TITLE_4')},
      {mode: 'entrepreneurs', title: this.l10n('HOME_NEW_MODES_TITLE_5')}
    ];

    const proposalSlides = {
      recommended: [
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_CASHBACK'),
          imgMobile: proposalSliderMobile3,
          imgTablet: proposalSliderTablet3,
          imgDesktop: proposalSliderDesktop3,
          imgMiddle: proposalSliderTabletMobile3,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_CASHBACK'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_CASHBACK'),
          link: URL_CASHBACK,
          background: `url(${cashbackBg}) center / cover no-repeat`,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_ATB'),
          imgMobile: proposalSliderMobile4,
          imgTablet: proposalSliderTablet4,
          imgDesktop: proposalSliderDesktop4,
          imgMiddle: proposalSliderTabletMobile4,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_ATB'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_ATB'),
          link: URL_ATB,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${atbBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_BOLT'),
          imgMobile: proposalSliderMobile2,
          imgTablet: proposalSliderTablet2,
          imgDesktop: proposalSliderDesktop2,
          imgMiddle: proposalSliderTabletMobile2,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_BOLT'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_BOLT'),
          link: URL_BOLT,
          background: `url(${boltBg}) center / cover no-repeat`,
          colorTitle: "#FFF",
          colorText: "#FFF",
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VYGODA'),
          imgMobile: proposalSliderMobile5,
          imgTablet: proposalSliderTablet5,
          imgDesktop: proposalSliderDesktop5,
          imgMiddle: proposalSliderTabletMobile5,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VYGODA'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VYGODA'),
          link: URL_VYGODA,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${vygodaBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VETERAN'),
          imgMobile: proposalSliderMobile6,
          imgTablet: proposalSliderTablet6,
          imgDesktop: proposalSliderDesktop6,
          imgMiddle: proposalSliderTabletMobile6,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VETERAN'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VETERAN'),
          link: URL_VETERAN,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${veteranBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_BOOK'),
          imgMobile: proposalSliderMobile7,
          imgTablet: proposalSliderTablet7,
          imgDesktop: proposalSliderDesktop7,
          imgMiddle: proposalSliderTabletMobile7,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_BOOK'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_BOOK'),
          link: URL_BOOK,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${bookBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_INSTALLMENT'),
          imgMobile: proposalSliderMobile8,
          imgTablet: proposalSliderTablet8,
          imgDesktop: proposalSliderDesktop8,
          imgMiddle: proposalSliderTabletMobile8,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_INSTTALLMENT'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_INSTTALLMENT'),
          link: URL_INSTALLMENT,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: "radial-gradient(180% 131.34% at 50% 0%, #DEFFEF 5.21%, #EAF4FF 44.79%, #FFF 100%), #FFF"
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_ENERGY'),
          imgMobile: proposalSliderMobile9,
          imgTablet: proposalSliderTablet9,
          imgDesktop: proposalSliderDesktop9,
          imgMiddle: proposalSliderTabletMobile9,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_ENERGY'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_ENERGY'),
          link: URL_ENERGY,
          colorTitle: "#FFF",
          colorText: "#FFFFFFCC",
          background: "#0D0C22"
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_PBP'),
          imgMobile: proposalSliderMobile11,
          imgTablet: proposalSliderTablet11,
          imgDesktop: proposalSliderDesktop11,
          imgMiddle: proposalSliderTabletMobile11,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_PBP'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_PBP'),
          link: URL_PBP,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${pbpBg}) center / cover no-repeat`,
        }
      ],
      youth: [
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_BOLT'),
          imgMobile: proposalSliderMobile2,
          imgTablet: proposalSliderTablet2,
          imgDesktop: proposalSliderDesktop2,
          imgMiddle: proposalSliderTabletMobile2,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_BOLT'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_BOLT'),
          link: URL_BOLT,
          background: `url(${boltBg}) center / cover no-repeat`,
          colorTitle: "#FFF",
          colorText: "#FFF",
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_CASHBACK'),
          imgMobile: proposalSliderMobile3,
          imgTablet: proposalSliderTablet3,
          imgDesktop: proposalSliderDesktop3,
          imgMiddle: proposalSliderTabletMobile3,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_CASHBACK'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_CASHBACK'),
          link: URL_CASHBACK,
          background: `url(${cashbackBg}) center / cover no-repeat`,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_ATB'),
          imgMobile: proposalSliderMobile4,
          imgTablet: proposalSliderTablet4,
          imgDesktop: proposalSliderDesktop4,
          imgMiddle: proposalSliderTabletMobile4,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_ATB'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_ATB'),
          link: URL_ATB,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${atbBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VYGODA'),
          imgMobile: proposalSliderMobile5,
          imgTablet: proposalSliderTablet5,
          imgDesktop: proposalSliderDesktop5,
          imgMiddle: proposalSliderTabletMobile5,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VYGODA'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VYGODA'),
          link: URL_VYGODA,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${vygodaBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VETERAN'),
          imgMobile: proposalSliderMobile6,
          imgTablet: proposalSliderTablet6,
          imgDesktop: proposalSliderDesktop6,
          imgMiddle: proposalSliderTabletMobile6,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VETERAN'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VETERAN'),
          link: URL_VETERAN,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${veteranBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_BOOK'),
          imgMobile: proposalSliderMobile7,
          imgTablet: proposalSliderTablet7,
          imgDesktop: proposalSliderDesktop7,
          imgMiddle: proposalSliderTabletMobile7,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_BOOK'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_BOOK'),
          link: URL_BOOK,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${bookBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_INSTALLMENT'),
          imgMobile: proposalSliderMobile8,
          imgTablet: proposalSliderTablet8,
          imgDesktop: proposalSliderDesktop8,
          imgMiddle: proposalSliderTabletMobile8,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_INSTTALLMENT'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_INSTTALLMENT'),
          link: URL_INSTALLMENT,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: "radial-gradient(180% 131.34% at 50% 0%, #DEFFEF 5.21%, #EAF4FF 44.79%, #FFF 100%), #FFF"
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_PBP'),
          imgMobile: proposalSliderMobile11,
          imgTablet: proposalSliderTablet11,
          imgDesktop: proposalSliderDesktop11,
          imgMiddle: proposalSliderTabletMobile11,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_PBP'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_PBP'),
          link: URL_PBP,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${pbpBg}) center / cover no-repeat`,
        }
      ],
      family: [
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_ATB'),
          imgMobile: proposalSliderMobile4,
          imgTablet: proposalSliderTablet4,
          imgDesktop: proposalSliderDesktop4,
          imgMiddle: proposalSliderTabletMobile4,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_ATB'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_ATB'),
          link: URL_ATB,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${atbBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_CASHBACK'),
          imgMobile: proposalSliderMobile3,
          imgTablet: proposalSliderTablet3,
          imgDesktop: proposalSliderDesktop3,
          imgMiddle: proposalSliderTabletMobile3,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_CASHBACK'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_CASHBACK'),
          link: URL_CASHBACK,
          background: `url(${cashbackBg}) center / cover no-repeat`,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_BOLT'),
          imgMobile: proposalSliderMobile2,
          imgTablet: proposalSliderTablet2,
          imgDesktop: proposalSliderDesktop2,
          imgMiddle: proposalSliderTabletMobile2,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_BOLT'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_BOLT'),
          link: URL_BOLT,
          background: `url(${boltBg}) center / cover no-repeat`,
          colorTitle: "#FFF",
          colorText: "#FFF",
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VYGODA'),
          imgMobile: proposalSliderMobile5,
          imgTablet: proposalSliderTablet5,
          imgDesktop: proposalSliderDesktop5,
          imgMiddle: proposalSliderTabletMobile5,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VYGODA'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VYGODA'),
          link: URL_VYGODA,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${vygodaBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VETERAN'),
          imgMobile: proposalSliderMobile6,
          imgTablet: proposalSliderTablet6,
          imgDesktop: proposalSliderDesktop6,
          imgMiddle: proposalSliderTabletMobile6,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VETERAN'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VETERAN'),
          link: URL_VETERAN,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${veteranBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_INSTALLMENT'),
          imgMobile: proposalSliderMobile8,
          imgTablet: proposalSliderTablet8,
          imgDesktop: proposalSliderDesktop8,
          imgMiddle: proposalSliderTabletMobile8,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_INSTTALLMENT'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_INSTTALLMENT'),
          link: URL_INSTALLMENT,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: "radial-gradient(180% 131.34% at 50% 0%, #DEFFEF 5.21%, #EAF4FF 44.79%, #FFF 100%), #FFF"
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_PBP'),
          imgMobile: proposalSliderMobile11,
          imgTablet: proposalSliderTablet11,
          imgDesktop: proposalSliderDesktop11,
          imgMiddle: proposalSliderTabletMobile11,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_PBP'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_PBP'),
          link: URL_PBP,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${pbpBg}) center / cover no-repeat`,
        }
      ],
      old: [
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_CASHBACK'),
          imgMobile: proposalSliderMobile3,
          imgTablet: proposalSliderTablet3,
          imgDesktop: proposalSliderDesktop3,
          imgMiddle: proposalSliderTabletMobile3,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_CASHBACK'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_CASHBACK'),
          link: URL_CASHBACK,
          background: `url(${cashbackBigBg}) center / cover no-repeat`,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_ATB'),
          imgMobile: proposalSliderMobile4,
          imgTablet: proposalSliderTablet4,
          imgDesktop: proposalSliderDesktop4,
          imgMiddle: proposalSliderTabletMobile4,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_ATB'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_ATB'),
          link: URL_ATB,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${atbBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VYGODA'),
          imgMobile: proposalSliderMobile5,
          imgTablet: proposalSliderTablet5,
          imgDesktop: proposalSliderDesktop5,
          imgMiddle: proposalSliderTabletMobile5,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VYGODA'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VYGODA'),
          link: URL_VYGODA,
          background: `url(${vygodaBg}) center / cover no-repeat`,
          colorTitle: "#090A0C",
          colorText: "#1B1E24"
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VETERAN'),
          imgMobile: proposalSliderMobile6,
          imgTablet: proposalSliderTablet6,
          imgDesktop: proposalSliderDesktop6,
          imgMiddle: proposalSliderTabletMobile6,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VETERAN'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VETERAN'),
          link: URL_VETERAN,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${veteranBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_INSTALLMENT'),
          imgMobile: proposalSliderMobile8,
          imgTablet: proposalSliderTablet8,
          imgDesktop: proposalSliderDesktop8,
          imgMiddle: proposalSliderTabletMobile8,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_INSTTALLMENT'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_INSTTALLMENT'),
          link: URL_INSTALLMENT,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: "radial-gradient(180% 131.34% at 50% 0%, #DEFFEF 5.21%, #EAF4FF 44.79%, #FFF 100%), #FFF"
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_PBP'),
          imgMobile: proposalSliderMobile11,
          imgTablet: proposalSliderTablet11,
          imgDesktop: proposalSliderDesktop11,
          imgMiddle: proposalSliderTabletMobile11,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_PBP'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_PBP'),
          link: URL_PBP,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${pbpBg}) center / cover no-repeat`,
        }
      ],
      entrepreneurs: [
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_ENERGY'),
          imgMobile: proposalSliderMobile9,
          imgTablet: proposalSliderTablet9,
          imgDesktop: proposalSliderDesktop9,
          imgMiddle: proposalSliderTabletMobile9,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_ENERGY'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_ENERGY'),
          link: URL_ENERGY,
          colorTitle: "#FFF",
          colorText: "#FFFFFFCC",
          background: "#0D0C22"
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VYGODA'),
          imgMobile: proposalSliderMobile5,
          imgTablet: proposalSliderTablet5,
          imgDesktop: proposalSliderDesktop5,
          imgMiddle: proposalSliderTabletMobile5,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VYGODA'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VYGODA'),
          link: URL_VYGODA,
          background: `url(${vygodaBg}) center / cover no-repeat`,
          colorTitle: "#090A0C",
          colorText: "#1B1E24"
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VETERAN'),
          imgMobile: proposalSliderMobile6,
          imgTablet: proposalSliderTablet6,
          imgDesktop: proposalSliderDesktop6,
          imgMiddle: proposalSliderTabletMobile6,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VETERAN'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VETERAN'),
          link: URL_VETERAN,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${veteranBg}) center / cover no-repeat`,
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_CASHBACK'),
          imgMobile: proposalSliderMobile3,
          imgTablet: proposalSliderTablet3,
          imgDesktop: proposalSliderDesktop3,
          imgMiddle: proposalSliderTabletMobile3,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_CASHBACK'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_CASHBACK'),
          link: URL_CASHBACK,
          background: `url(${cashbackBigBg}) center / cover no-repeat`,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
        },
        {
          tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_PBP'),
          imgMobile: proposalSliderMobile11,
          imgTablet: proposalSliderTablet11,
          imgDesktop: proposalSliderDesktop11,
          imgMiddle: proposalSliderTabletMobile11,
          title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_PBP'),
          text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_PBP'),
          link: URL_PBP,
          colorTitle: "#090A0C",
          colorText: "#1B1E24",
          background: `url(${pbpBg}) center / cover no-repeat`,
        }
      ]
    }

    return (
        <div className='module-home-new'>
          <div className="hero" ref={this.heroRef}>
            <div className="hero-background">
                <img src={backgroundLine} alt="hero-background-image"/>
            </div>
            <div className="hero-content">
              <div className="hero-title" dangerouslySetInnerHTML={{ __html: this.l10n('HOME_NEW_HERO_TITLE') }}></div>
              <p className="hero-text">{this.l10n('HOME_NEW_HERO_TEXT')}</p>
              <Link href={URL_SERVICES} onClick={e => this.navigate(URL_SERVICES, e)} className="hero-button">{this.l10n('HOME_NEW_HERO_LINK')}</Link>
              <img src={heroArrow1} alt="hero-arrow-1" className="hero-arrow hero-arrow--top-left"/>
              <img src={heroArrow2} alt="hero-arrow-2" className="hero-arrow hero-arrow--top-right"/>
              <img src={heroArrow3} alt="hero-arrow-3" className="hero-arrow hero-arrow--bottom-left"/>
              <img src={heroArrow4} alt="hero-arrow-4" className="hero-arrow hero-arrow--bottom-right"/>
            </div>
          </div>
          <div className="proposal">
              <div className="proposal-header desktop">
                <div className="slider-row container">
                  <div className="slider-tabs">
                    {modes.map((item, index) => (
                      <button 
                        key={index} 
                        className={`slider-tab slider-tab-${index + 1} ${this.state.mode === item.mode ? 'selected' : ''}`} 
                        onClick={() => this.toggleMode(item.mode)}
                      >
                        {item.img ? <img src={item.img} alt={`proposal tab ${item.title}`} /> : item.title}
                      </button>
                    ))}
                  </div>
                  <div className="slider-controls">
                    <button onClick={this.prevProposalSlide} className="slider-btn slider-btn-1">
                      <img src={moreSliderArrow1} alt="slider pagination arrow left" />
                    </button>
                    <button onClick={this.nextProposalSlide} className="slider-btn slider-btn-2">
                      <img src={moreSliderArrow2} alt="slider pagination arrow right" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="proposal-header mobile">
                <div className="slider-row">
                  <div className="slider-tabs">
                    <div className="slider-container slider-container-tabs">
                      <Slider ref={this.sliderRefTabs} {...settingsTabs}>
                        {modes.map((item, index) => (
                          <button 
                            key={index} 
                            className={`slider-tab slider-tab-${index + 1} ${this.state.mode === item.mode ? 'selected' : ''}`} 
                            onClick={() => this.toggleMode(item.mode)}
                          >
                            {item.img ? <img src={item.img} alt={`proposal tab ${item.title}`} /> : item.title}
                          </button>
                        ))}
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
              <div className="proposal-header tablet">
                <div className="slider-row container">
                  <div className={`slider-dropdown proposal-dropdown ${this.state.isOpen ? 'proposal-dropdown-active' : ''}`} ref={this.dropdownRef}>
                    <div onClick={this.toggleDropdown} className="proposal-dropdown-top">
                      <button className="proposal-dropdown-title">
                        {modes.find(m => m.mode === this.state.mode)?.img && (
                                  <img 
                                    src={modes.find(m => m.mode === this.state.mode).img} 
                                    alt={`proposal tab ${modes.find(m => m.mode === this.state.mode).title}`}
                                    className="proposal-dropdown-image"
                                  />
                                )}
                        <span>{modes.find(m => m.mode === this.state.mode)?.title}</span>
                        <img src={proposalArrow} alt="proposal-dropdown arrow" className="proposal-dropdown-arrow"/>
                      </button>
                    </div>
                    <ul className="proposal-dropdown-list">
                      {modes
                        .filter(item => item.mode !== this.state.mode) 
                        .map((item) => (
                          <li
                            key={item.mode}
                            onClick={() => this.toggleMode(item.mode)}
                            className="proposal-dropdown-item"
                          >
                            {item.title}
                          </li>
                        ))}
                    </ul>

                  </div>
                  <div className="slider-controls">
                    <button onClick={this.prevProposalSlide} className="slider-btn slider-btn-1">
                      <img src={moreSliderArrow1} alt="slider pagination arrow left" />
                    </button>
                    <button onClick={this.nextProposalSlide} className="slider-btn slider-btn-2">
                      <img src={moreSliderArrow2} alt="slider pagination arrow right" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="proposal-bottom slider-container slider-container-proposal" ref={this.sliderRefProposalContainer}>
                <Slider ref={this.sliderRefProposal} {...settingsProposal} key={this.state.mode}>
                  {proposalSlides[this.state.mode].map((item, index) => (
                    <div key={index} className={`slide slide-${index + 1}`}>
                      <div
                        className="slide-item"
                        onMouseDown={this.handleMouseDown}
                        onMouseUp={(e) => this.handleMouseUp(e, () => this.navigate(item.link, e))}
                        style={{ background: item.background }}
                      >
                        <div className="slide-tag">{item.tag}</div>
                        <div className={`slide-title ${item.link === URL_BOLT ? 'bolt' : ''} slide-${index + 1}`} style={{ color: item.colorTitle }}>{item.title}</div>
                        <div className="slide-body">
                          <div className="slide-text" style={{ color: item.colorText }}>{item.text}</div>
                          {index === 0 && isDesktop && (
                            <div className="slide-image">
                              <img src={item.imgDesktop} alt={item.title} style={{ width: '688px'}} />
                            </div>
                          )}
                          {index === 0 && isTablet && (
                            <div className="slide-image">
                              <img src={item.imgTablet} alt={item.title} style={{ width: '344px'}} />
                            </div>
                          )}
                          {index !== 0 && (isDesktop || isTablet) && (
                            <div className="slide-image">
                              <img src={item.imgTablet} alt={item.title} style={{ width: '344px' }} />
                            </div>
                          )}
                          {isMobile && (
                            <div className="slide-image">
                              <img src={item.imgMobile} alt={item.title} style={{ width: '288px' }} />
                            </div>
                          )}
                          {isMiddle && (
                            <div className="slide-image">
                              <img src={item.imgMiddle} alt={item.title} style={{ width: '344px' }} />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
          </div>
          <div className="services">
            <div className="container">
              <div className="services-title">{this.l10n('HOME_NEW_SERVICES_TITLE') }</div>
              <div className="services-row">
                <div className="services-left left-services">
                  <div className="left-services-top">
                    <ExchangeRatesNew {...this.props} />
                  </div>
                  <div className="left-services-bottom" dangerouslySetInnerHTML={{ __html: this.l10n('HOME_NEW_SERVICES_LEFT_TEXT') }}></div>
                </div>
                <div className="services-right right-services">
                  <div className="right-services-row" onClick={e => this.navigate(URL_BRANCHES, e)}>
                    <div className="right-services-column">
                      <div className="right-services-title">{this.l10n('HOME_NEW_SERVICES_RIGHT_TITLE_1') }</div>
                      <div className="right-services-text">{this.l10n('HOME_NEW_SERVICES_RIGHT_TEXT_1') }</div>
                    </div>
                    <img src={servicesRight1} alt="image branches" />
                  </div>
                  <div className="right-services-row" onClick={e => this.navigate(URL_SERVICES, e)}>
                    <div className="right-services-column">
                      <div className="right-services-title">{this.l10n('HOME_NEW_SERVICES_RIGHT_TITLE_2') }</div>
                      <div className="right-services-text">{this.l10n('HOME_NEW_SERVICES_RIGHT_TEXT_2') }</div>
                    </div>
                    <img src={servicesRight2} alt="image abank24" />
                  </div>
                  <div className="right-services-row" onClick={e => this.navigate(URL_CONTACTS, e)}>
                    <div className="right-services-column">
                      <div className="right-services-title right-services-title-white">{this.l10n('HOME_NEW_SERVICES_RIGHT_TITLE_3') }</div>
                      <div className="right-services-text right-services-text-white">{this.l10n('HOME_NEW_SERVICES_RIGHT_TEXT_3')}</div>
                    </div>
                    <img src={servicesRight3} alt="image contacts" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="more">
            <div className="slider-header">
              <div className="slider-row container">
                <div className="slider-title">{this.l10n('HOME_NEW_MORE_TITLE') }</div>
                <div className="slider-controls">
                  <button onClick={this.prevSlide} className="slider-btn slider-btn-1">
                    <img src={moreSliderArrow1} alt="slider pagination arrow left" />
                  </button>
                  <button onClick={this.nextSlide} className="slider-btn slider-btn-2">
                    <img src={moreSliderArrow2} alt="slider pagination arrow right" />
                  </button>
                </div>
              </div>
            </div>
            <div ref={this.sliderRefContainer} className="slider-container slider-container-more">
              <Slider ref={this.sliderRefMore} {...settings}>
                  {slides.map((item, index) => (
                    <div key={index} className="slide" onMouseDown={this.handleMouseDown} onMouseUp={(e) => this.handleMouseUp(e, () => this.navigate(item.link, e))}>
                      <div className="slide-image">
                        <img src={item.img} alt={`more slide ${index + 1}`} style={{width: 392}}/>
                      </div>
                      <div className="slide-content">
                        <div className="slide-title">{item.title}</div>
                        <div className="slide-text">{item.text}</div>
                      </div>
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
          <div className="search">
            <div className="container">
              <div className='search-title' dangerouslySetInnerHTML={{ __html: this.l10n('HOME_NEW_SEARCH_TITLE') }}></div>
              <form className="search-form">
                <img className='search-icon' src={searchIcon} alt="search icon"/>
                <input type="text" onClick={e => this.navigate(URL_SEARCH, e)} className="search-input" placeholder="Що б ви хотіли знайти?"/>
                <button type="submit" onClick={e => this.navigate(URL_SEARCH, e)} className="search-button">Пошук</button>
              </form>
            </div>
          </div>
          <NewsNew navigate={this.navigate}/>
        </div>
    );
}
